export default __webpack_public_path__ + "static/media/about-pic.5f1757d3.png";